// The one copy key per prompt-var scope, shared by the three surfaces that name
// one: the form's picker, the list's filter and the table row's badge. The wire
// value stays the DOMAIN enum (`account` / `repo` / `template`) — it is the
// address the API parses — and only the label is translated, so a locale can
// never rename a scope out from under a write.
//
// Literal keys in a lookup rather than an interpolated `t(\`…${scope}\`)`, the
// `MACHINE_STATUS` convention (`lib/machine-labels.ts`), so every key the bundle can render stays
// greppable and a fourth scope cannot be spelled three different ways.

import type { PromptVarScope } from '@developerz/domain';

export const PROMPT_VAR_SCOPE_LABEL: Record<PromptVarScope, string> = {
  account: 'account_prompt_vars.scope_account',
  repo: 'account_prompt_vars.scope_repo',
  template: 'account_prompt_vars.scope_template',
};
